<script lang="ts">
	import { cfgStage, Stage } from '@infinitro/config';
	import { loggedIn, ModalDialog, modalStack, stateOpenModal } from '@infinitro/global';
	import { LoadingManager } from '@infinitro/loading';
	import { ErrorModal, LoadingModal } from '@infinitro/modal';
	import { onMount } from 'svelte';
	import LazyComponent from '$lib/lazy-component.svelte';

	const loadAuthModal = () => import('@infinitro/auth').then((m) => m.AuthModal);

	const AUTH_PREFETCH_TIMEOUT_MS = 5000;

	const prefetchAuthModal = () =>
		loadAuthModal().catch((error: unknown) =>
			console.error('[modals] failed to prefetch the auth modal', error)
		);

	onMount(() => {
		if (typeof requestIdleCallback === 'function') {
			const handle = requestIdleCallback(prefetchAuthModal, { timeout: AUTH_PREFETCH_TIMEOUT_MS });
			return () => cancelIdleCallback(handle);
		}
		const timer = setTimeout(prefetchAuthModal, AUTH_PREFETCH_TIMEOUT_MS);
		return () => clearTimeout(timer);
	});
</script>

<div class="modals">
	<LoadingManager customClass="fixed-loading-screen" waitForLoggedIn={true} />
	{#if (!$loggedIn && $stateOpenModal && [ModalDialog.Auth, ModalDialog.Login, ModalDialog.Signup].includes($stateOpenModal)) || $modalStack.some( (e) => [ModalDialog.Auth, ModalDialog.Login, ModalDialog.Signup].includes(e.modal) )}
		<LazyComponent load={loadAuthModal} />
	{/if}
	{#if $stateOpenModal === ModalDialog.BetSlip || $modalStack.some((e) => e.modal === ModalDialog.BetSlip)}
		<LazyComponent load={() => import('@infinitro/bet-feed').then((m) => m.BetSlipModal)} />
	{/if}
	{#if $stateOpenModal === ModalDialog.DevSettings || $modalStack.some((e) => e.modal === ModalDialog.DevSettings)}
		{#if cfgStage() === Stage.Prod}
			<LazyComponent load={() => import('@infinitro/dev_modals').then((m) => m.ProdSettings)} />
		{:else}
			<LazyComponent load={() => import('@infinitro/dev_modals').then((m) => m.DevSettings)} />
		{/if}
	{/if}
	{#if $stateOpenModal === ModalDialog.GameInfo || $modalStack.some((e) => e.modal === ModalDialog.GameInfo)}
		<LazyComponent load={() => import('@infinitro/game-page').then((m) => m.GameInfoModal)} />
	{/if}
	{#if $stateOpenModal === ModalDialog.Search || $modalStack.some((e) => e.modal === ModalDialog.Search)}
		<LazyComponent load={() => import('@infinitro/sidebar').then((m) => m.SearchModal)} />
	{/if}
	{#if $stateOpenModal === ModalDialog.Update || $modalStack.some((e) => e.modal === ModalDialog.Update)}
		<LazyComponent load={() => import('@infinitro/notifications').then((m) => m.UpdateModal)} />
	{/if}
	{#if $stateOpenModal === ModalDialog.VipClub || $modalStack.some((e) => e.modal === ModalDialog.VipClub)}
		<LazyComponent load={() => import('@infinitro/about-vip').then((m) => m.RanksModal)} />
	{/if}
	{#if $stateOpenModal === ModalDialog.WelcomeModal || $modalStack.some((e) => e.modal === ModalDialog.WelcomeModal)}
		<LazyComponent load={() => import('@infinitro/auth').then((m) => m.WelcomeModal)} />
	{/if}
	{#if $stateOpenModal === ModalDialog.LuckyDip || $modalStack.some((e) => e.modal === ModalDialog.LuckyDip)}
		<LazyComponent load={() => import('@infinitro/lucky-dip').then((m) => m.LuckyDip)} />
	{/if}
	{#if $stateOpenModal === ModalDialog.Geoblock || $modalStack.some((e) => e.modal === ModalDialog.Geoblock)}
		<LazyComponent load={() => import('@infinitro/geoblock').then((m) => m.GeoBlock)} />
	{/if}
	{#if $stateOpenModal === ModalDialog.Maintenance || $modalStack.some((e) => e.modal === ModalDialog.Maintenance)}
		<LazyComponent load={() => import('@infinitro/geoblock').then((m) => m.Maintenance)} />
	{/if}
	{#if $stateOpenModal === ModalDialog.FeatureUnavailable || $modalStack.some((e) => e.modal === ModalDialog.FeatureUnavailable)}
		<LazyComponent
			load={() => import('@infinitro/feature-unavailable').then((m) => m.FeatureUnavailable)}
		/>
	{/if}
	{#if $stateOpenModal === ModalDialog.WalletVerify || $modalStack.some((e) => e.modal === ModalDialog.WalletVerify)}
		<LazyComponent
			load={() => import('@infinitro/wallet_verify').then((m) => m.WalletVerifyModal)}
		/>
	{/if}
	{#if $stateOpenModal === ModalDialog.Loading || $modalStack.some((e) => e.modal === ModalDialog.Loading)}
		<LoadingModal />
	{/if}
	{#if $stateOpenModal === ModalDialog.EmailVerify || $modalStack.some((e) => e.modal === ModalDialog.EmailVerify)}
		<LazyComponent load={() => import('@infinitro/email_verify').then((m) => m.EmailVerifyModal)} />
	{/if}
	{#if $stateOpenModal === ModalDialog.TotpVerify || $modalStack.some((e) => e.modal === ModalDialog.TotpVerify)}
		<LazyComponent load={() => import('@infinitro/totp_verify').then((m) => m.Modal)} />
	{/if}
	{#if $stateOpenModal === ModalDialog.TotpSetup || $modalStack.some((e) => e.modal === ModalDialog.TotpSetup)}
		<LazyComponent load={() => import('@infinitro/totp_setup').then((m) => m.Modal)} />
	{/if}
	{#if $stateOpenModal === ModalDialog.Error || $modalStack.some((e) => e.modal === ModalDialog.Error)}
		<ErrorModal />
	{/if}
</div>

<style lang="postcss">
	.modals {
		z-index: 61;
	}
</style>
